exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbnails > .row[data-v-665c7f1c] {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -8px;\n  margin-left: -8px;\n}\n.thumbnails > .row > div[data-v-665c7f1c] {\n  display: flex;\n  padding-right: 8px;\n  padding-left: 8px;\n}", ""]);

// exports
